import { render, staticRenderFns } from "./IconDownloadSolid.vue?vue&type=template&id=f5009212"
import script from "./IconDownloadSolid.vue?vue&type=script&lang=js"
export * from "./IconDownloadSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports